module.exports = __webpack_public_path__ + "img/category04.4263a476.png";